import { Exceptiondt2hlxn7j7vw as Exception } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toThrowable(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof Error ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? Exception().xd("Promise resolved with a non-Throwable exception '" + _this__u8e3s4.toString() + "' (type " + toString(getKClassFromExpression(_this__u8e3s4)) + ')') : tmp0_elvis_lhs;
}
function toJsPromiseError(_this__u8e3s4) {
  return _this__u8e3s4;
}
//region block: exports
export {
  toJsPromiseError as toJsPromiseError2wscsct4f14gh,
  toThrowable as toThrowable1tarb5uizt368,
};
//endregion

//# sourceMappingURL=Promise.js.mjs.map
